import React from "react";
import { Box } from "@mui/material";

import StudyTable from "./StudyTable";
import GeneralHeader from "../GeneralHeader/GeneralHeader";

const StudyPage: React.FC = () => {
  const createStyles = () => ({
    root: {
      width: "100%",
      height: "100vh",
    },
  });
  const classes = createStyles();

  return (
    <>
      <Box sx={classes.root}>
        <GeneralHeader></GeneralHeader>
        <StudyTable />
      </Box>
    </>
  );
};
export default StudyPage;
